import type { TrainingLessonSpecific } from './trainingLessonUi';

export const teacher2ReverenceEn: TrainingLessonSpecific = {
  intro:
    'This lesson focuses on real execution: reverence, supporting leaders, simple ministering, and how a teacher upholds spiritual order without becoming harsh.',
  objectives: [
    'Understand how a teacher promotes reverence without conflict or shame.',
    'Learn to support leaders (bishopric/quorum) with orderly initiative.',
    'Practice simple ministering: notice, approach, invite, accompany.',
    'Improve teamwork with deacons/priests (without competing).',
    'Set a weekly plan: reverence + service + strengthening.',
  ],
  briefHeading: 'Reverence and service in practice',
  briefBody:
    'A steadfast teacher invites order with meekness, supports bishoprics and presidencies, ministers with simple gestures, and works with deacons and priests. The goal is an environment where others can worship with the Spirit.',
  scriptures: [
    { ref: 'D&C 121:43–44', text: '…reproving betimes with sharpness, when moved upon by the Holy Ghost; and then showing forth afterwards an increase of love…' },
    { ref: 'Moroni 6:5–6', text: '…their meetings were conducted by the church… to pray… and to exhort one another…' },
    { ref: 'D&C 20:53–54', text: '…see that there is no iniquity in the church, nor hardness with each other…' },
    { ref: 'Matthew 5:16', text: 'Let your light so shine before men…' },
    { ref: 'Philippians 2:3–4', text: '…in lowliness of mind let each esteem other better than themselves…' },
  ],
  didYouKnow: [
    'Reverence is not “being quiet from fear”: it is focusing the heart on Christ and covenants.',
    'A strong teacher is not the one who bosses: it is the one who serves and improves the atmosphere where others can worship.',
  ],
  practiceItems: [
    'Before the meeting: pick one “focus point” (e.g., listen for one talk idea and write it down)',
    'Reverence without arguing: practice two gentle phrases to invite order',
    'Support leaders: ask a leader “What can I help with today?” and do it',
    'Simple ministering: talk with one person (new, alone, shy youth) and offer a brief invitation',
    'Teamwork: help a deacon or priest finish a task without scolding',
    'Self-review: write one thing you did well and one to improve next Sunday',
  ],
  reflectionQuestions: [
    'What distractions steal my reverence? How will I cut them?',
    'Who can I strengthen this week with a simple gesture?',
    'How can I correct without pride and serve without seeking recognition?',
  ],
  actionText:
    'Intentional Sunday: choose one fixed habit for each Sunday (e.g., arrive early, pray first, sit nearer the front, note one idea and apply it).',
};
